module.exports = __webpack_public_path__ + "static/media/map-outline-01.bd80f64a.svg";